import React, { Fragment } from "react";
import { useStateValue } from "../StateProvider";
import "./Cart.css";
import { useAuth0 } from "@auth0/auth0-react";
import CartItem from "./CartItem";
import CartSidebar from "./CartSidebar";
import { useNavigate } from "react-router-dom";
function Cart() {
  const history=useNavigate();
  const [{ cart },dispatch] = useStateValue();
  const clear_cart=()=>{
    dispatch({
      type:'CLEAR_CART'
    })
  }
  const orderedPlaced=()=>{
    history('/order');
    localStorage.removeItem('Cart')
  }
  const { loginWithRedirect ,isAuthenticated } = useAuth0();
  console.log(cart);
  return (
    <Fragment>
      {cart?.length === 0 ? (
        <div className="cart_empty">
          <img src="https://rukminim1.flixcart.com/www/800/800/promos/16/05/2019/d438a32e-765a-4d8b-b4a6-520b560971e8.png?q=90" />
          <h5>Your cart is empty!</h5>
          <p>Explore our wide selection and find something you like</p>
        </div>
      ) : (
        <div className="cart">
          <div className="cart_left">
            {cart?.map((item) => (
              <CartItem
                key={item.id}
                id={item.id}
                description={item.description}
                title={item.title}
                price={item.price}
                thumbnail={item.thumbnail}
                rating={item.rating}
              />
            ))}
          </div>
          <div className="cart_right">{cart?.length > 0 && <CartSidebar />}</div>
        <div className="cart_PlaceOrder">
         {isAuthenticated?
         <button onClick={()=>{
          clear_cart() 
          orderedPlaced()}}>Place Order </button>:
         <button onClick={() => loginWithRedirect()}>Login</button>

         
        }
        </div>
        </div>
      )}
    </Fragment>
  );
}

export default Cart;
